interface QRCodeModalProps {
  phone: string;
  rolLabel: string;
  qrDataUrl: string;
  status: string;
  onClose: () => void;
}

export default function QRCodeModal({ phone, rolLabel, qrDataUrl, status, onClose }: QRCodeModalProps) {
  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="qr-modal-header">
          <div className="qr-phone-badge">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <span>{phone}</span>
          </div>
          <span className="qr-rol-badge">{rolLabel}</span>
        </div>

        <div className="qr-image-container">
          {status === "qr" || status === "pending" ? (
            <img src={qrDataUrl} alt="Código QR de WhatsApp" className="qr-image" />
          ) : (
            <div className="qr-loading">
              <div className="spinner" />
              <p>Esperando código QR...</p>
            </div>
          )}
        </div>

        <div className="qr-instructions">
          <h4>Escanea con WhatsApp</h4>
          <ol>
            <li>Abre WhatsApp en tu teléfono</li>
            <li>Toca el menú ⋮ (Android) o ⚙️ (iPhone)</li>
            <li>Selecciona <strong>WhatsApp Web</strong></li>
            <li>Escanea este código QR</li>
          </ol>
        </div>

        <div className="qr-footer">
          <span className="qr-status-text">
            Estado: <strong>{status === "pending" ? "Esperando QR..." : "Listo para escanear"}</strong>
          </span>
        </div>
      </div>
    </div>
  );
}